import { createApiClient } from "@medme/api-client"
import { createAuthFlow, saveAuthenticationTokens } from "@medme/auth"
import { getAppConfig } from "@/app/config/app-config"
import { customFetch as customOAuthFetch } from "@/shared/api/custom-oauth-client"

export type { BodyType, ErrorType } from "@medme/api-client"

const { refreshAuthTokens } = createAuthFlow(customOAuthFetch)

const apiClient = createApiClient({
	getBaseUrl: () => getAppConfig().corev2ApiUrl,
	onUnauthorized: async () => {
		const tokens = await refreshAuthTokens()
		if (!tokens) {
			return false
		}
		saveAuthenticationTokens({
			token: tokens.access_token,
			refreshToken: tokens.refresh_token,
		})
		return true
	},
})

/**
 * The browser attaches the HttpOnly session cookie on its own
 * (`credentials: "include"` inside the api client). corev2 reads `user` and
 * the session token from that JWT.
 */
export const customFetch = <T>(url: string, options: RequestInit): Promise<T> =>
	apiClient<T>(url, options)
